import { Box, Card, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useTranslate } from "src/locales";
import { useEffect, useState } from "react";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import PatientDatas from "src/modules/medcard/patient-datas";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { GridColDef } from "@mui/x-data-grid-pro";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import {
  catheterMaterialFirstRows,
  catheterMaterialSecondRows,
} from "../models/rows";
import ChangePanel from "../change-panel";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ComplicationTypePanel from "../complication-type";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
//IDOGAN;453142;03042025
function CatheterMaterialTrackingCreate() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const [changePanelOpen, setChangePanelOpen] = useState(false);
  const [defaultProcessType, setDefaultProcessType] = useState<
    string | undefined
  >(undefined);
  

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    // medcardService.create('data1', 5);
    // medcardService.delete('data2', 5);
    // medcardService.save('data3', 5);
  }, []);

  const handleCreateMedcardData = async () => {
    setDefaultProcessType(undefined); // işlem tipi boş olsun
    setPanelMode("create"); // yeni bir mod tanımlayacağız
    setChangePanelOpen(true); // paneli aç
    try {
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };

  const handleSaveMedcard = async () => {
    try {
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };
  const [complicationDialogOpen, setComplicationDialogOpen] = useState(false);
  const { t } = useTranslate();
  const [panelMode, setPanelMode] = useState<"edit" | "remove" | "create">("edit");
  const catheterMaterialFirstColumns: GridColDef[] = [
    {
      field: "selection",
      headerName: t("catheter-material-tracking.select"),
      width: 80,
      renderCell: () => <ByzMuiCheckBox />,
    },
    {
      field: "actions",
      headerName: "",
      width: 80,
      renderCell: (params) => (
        <ByzMuiOpenProcessMenu
          hideHeaderTitle
          menuItems={[
            {
              label: t("catheter-material-tracking.edit"),
              onClick: () => {
                setDefaultProcessType(undefined);
                setPanelMode("edit");
                setChangePanelOpen(true);
              },
            },
            {
              label: t("catheter-material-tracking.remove"),
              onClick: () => {
                setDefaultProcessType(t("catheter-material-tracking.removal-operation"));
                setPanelMode("remove");
                setChangePanelOpen(true);
              },
            },
            {
              label: t("catheter-material-tracking.enter-complication"),
              onClick: () => setComplicationDialogOpen(true),
            },
          ]}
        />
      ),
    },
    { field: "lastProcessType", headerName: t("catheter-material-tracking.last-process-type"), flex: 1 },
    { field: "processName", headerName: t("catheter-material-tracking.last-process-name"), flex: 1 },
    { field: "user", headerName: t("catheter-material-tracking.performed-by"), flex: 1 },
    { field: "time", headerName: t("catheter-material-tracking.process-time"), flex: 1 },
    { field: "complicationType", headerName: t("catheter-material-tracking.complication-type"), flex: 1 },
    {
      field: "complicationDegree",
      headerName:t("catheter-material-tracking.complication-degree"),
      flex: 1,
    },
    {
      field: "complicationDesc",
      headerName: t("catheter-material-tracking.complication-description"),
      flex: 1,
    },
  ];
  const catheterMaterialSecondColumns: GridColDef[] = [
    { field: "processType", headerName: t("catheter-material-tracking.procedure-type"), flex: 1 },
    { field: "entryLocation", headerName: t("catheter-material-tracking.body-entry-location"), flex: 1 },
    { field: "region", headerName: t("catheter-material-tracking.region"), flex: 1 },
    { field: "reason", headerName: t("catheter-material-tracking.application-reason"), flex: 1 },
    { field: "applier", headerName: t("catheter-material-tracking.applied-by"), flex: 1 },
    { field: "stayDuration", headerName: t("catheter-material-tracking.stay-duration"), flex: 1 },
    { field: "expectedDuration", headerName: t("catheter-material-tracking.expected-duration"), flex: 1 },
  ];

  return (
    <>
      <PatientDatas isOpenMedCard={true} isCreateMedCard={true} />
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" spacing={2}>
          <ByzNurseSaveButton onClick={handleSaveMedcard} />
          <ByzMuiAddButton onClick={handleCreateMedcardData} />
          <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
          <ByzNursePrintButton2 />
        </Stack>
      
        <ByzMuiCloseButton onClick={() => setComplicationDialogOpen(false)} />
      </Stack>
      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />
      <Box sx={{width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={12} xs={12}>
            <Card sx={{ padding: 2 }}>
            <Box
              sx={{
                backgroundColor: "#F4F7FE",
                padding: "8px",
                borderBottom: "1px solid #E0E0E0",
                marginBottom: "8px",
              }}
            >
              <ByzMuiTypography
                isTitle
                sx={{ marginLeft: "5px", padding: "8px" }}
              >
                {t("catheter-material-tracking.catheter-material-tracking-title")}
              </ByzMuiTypography>
            </Box>
              <Divider sx={{ my: 2 }} />
              <ByzMuiDataGrid
                columns={catheterMaterialFirstColumns}
                rows={catheterMaterialFirstRows}
                pageSize={10}
                getRowId={(row) => row.id}
              />
            </Card>
          </Grid>

          <Grid md={12} xs={12} mt={4}>
            <Card sx={{ padding: 2 }}>
            <Box
              sx={{
                backgroundColor: "#F4F7FE",
                padding: "8px",
                borderBottom: "1px solid #E0E0E0",
                marginBottom: "8px",
                height:"56px"
              }}
            >
            </Box>
              <Divider sx={{ my: 2 }} />
              <ByzMuiDataGrid
                columns={catheterMaterialSecondColumns}
                rows={catheterMaterialSecondRows}
                pageSize={10}
                getRowId={(row) => row.id}
              />
            </Card>
          </Grid>
        </Grid>

        <Grid md={12} xs={12} mt={4}>
          <Card sx={{ padding: 2 }}>
            <Box
              sx={{
                backgroundColor: "#F4F7FE",
                padding: "8px",
                borderBottom: "1px solid #E0E0E0",
                marginBottom: "8px",
              }}
            >
              <ByzMuiTypography
                isTitle
                sx={{ marginLeft: "5px", padding: "8px" }}
              >
                {t("catheter-material-tracking.notes")}
              </ByzMuiTypography>
            </Box>
            <Box
              sx={{
                backgroundColor: "#F4F7FE",
                padding: "8px",
                borderBottom: "1px solid #E0E0E0",
                marginBottom: "10px",
              }}
            >
              <ByzMuiTypography
                isTitle
                sx={{ marginLeft: "5px", padding: "8px" }}
              >
                {t("catheter-material-tracking.application-vein-entry")}
              </ByzMuiTypography>
            </Box>
            <Box sx={{ padding: "8px", borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("catheter-material-tracking.application-vein-entry")}
              </ByzMuiTypography>
            </Box>

            <Box
              sx={{
                backgroundColor: "#F4F7FE",
                padding: "8px",
                borderBottom: "1px solid #E0E0E0",
                marginBottom: "10px",
              }}
            >
              <ByzMuiTypography
                isTitle
                sx={{ marginLeft: "5px", padding: "8px" }}
              >
                {t("catheter-material-tracking.infection-problem")}
              </ByzMuiTypography>
            </Box>
            <Box sx={{ padding: "8px" }}>
              <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("catheter-material-tracking.application-vein-entry")}
              </ByzMuiTypography>
            </Box>
          </Card>
        </Grid>
        <ByzMuiSnackBar
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          title={
            alertSeverity === "success" ? t("operation-successful") : t("error")
          }
          message={alertMessage}
          type={alertSeverity}
        />
        <OpenComponentDialog
          open={changePanelOpen}
          showSaveButton={true}
          onClose={() => setChangePanelOpen(false)}
          PaperProps={{
            sx: {
              width: "50%",
            },
          }}
        >
          <ChangePanel
            defaultProcessType={defaultProcessType}
            mode={panelMode}
          />
        </OpenComponentDialog>
        <OpenComponentDialog
          open={complicationDialogOpen}
          onClose={() => setComplicationDialogOpen(false)}
          showSaveButton
          PaperProps={{
            sx: {
              width: "60%",
              height: "650px",
            },
          }}
        >
          <ComplicationTypePanel />
        </OpenComponentDialog>
      </Box>
    </>
  );
}

export default CatheterMaterialTrackingCreate;
